import {
    Typography,
    FormControlLabel,
    Switch,
    Grid,
} from '@mui/material';
import { FormikProps } from 'formik';
import { CustomerTypes } from '../../../../../types';
import { SettingsFieldCard } from './settings-field-card';

interface Props {
    formik: FormikProps<CustomerTypes.OnboardingForm>;
    /**
     * Every field on this tab is a v2 catalog setting, so the whole tab is
     * read-only. Defaults to disabled so a caller that forgets the prop
     * cannot reopen a legacy write path.
     */
    disabled?: boolean;
}

export const MapLocationSettingsTab: React.FC<Props> = ({ formik, disabled = true }) => {
    const { values } = formik;

    const handleFieldChange = (field: string, value: any) => {
        formik.setFieldValue(field, value);
    };

    return (
        <>
            <Typography fontWeight={500} fontSize={18} mt={2}>
                Map & Location
            </Typography>
            <Typography fontSize={14} mb={1} color="text.secondary">
                Control how device locations and location-based features behave for this organization.
            </Typography>

            {/* Show Device Location on Map */}
            <SettingsFieldCard>
                <FormControlLabel
                    control={
                        <Switch
                            checked={values?.mapSettingsDeviceEnabled ?? true}
                            onChange={(e) => handleFieldChange('mapSettingsDeviceEnabled', e.target.checked)}
                            disabled={disabled}
                        />
                    }
                    label=""
                    sx={{ my: "auto" }}
                />
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>Show Device Location on Map</Typography>
                    <Typography color="textSecondary" variant="body2">
                        Display POM user device locations on the Event Map dashboard. When disabled, locations are only visible during active alerts.
                    </Typography>
                </Grid>
            </SettingsFieldCard>

            {/* Proximity to Reports Notification */}
            <SettingsFieldCard>
                <FormControlLabel
                    control={
                        <Switch
                            checked={values?.proximityToReportsNotification ?? false}
                            onChange={(e) => handleFieldChange('proximityToReportsNotification', e.target.checked)}
                            disabled={disabled}
                        />
                    }
                    label=""
                    sx={{ my: "auto" }}
                />
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>Proximity to Reports Notification</Typography>
                    <Typography color="textSecondary" variant="body2">
                        Send notifications to users when they are near Field Safety Reports or Intake Risk Assessments.
                    </Typography>
                </Grid>
            </SettingsFieldCard>

            {/* Activity Status Filters */}
            <SettingsFieldCard>
                <FormControlLabel
                    control={
                        <Switch
                            checked={values?.activityStatusFiltersEnabled ?? true}
                            onChange={(e) => handleFieldChange('activityStatusFiltersEnabled', e.target.checked)}
                            disabled={disabled}
                        />
                    }
                    label=""
                    sx={{ my: "auto" }}
                />
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>Activity Status Filters</Typography>
                    <Typography color="textSecondary" variant="body2">
                        Show user activity filters (Active Now, Last 3 Hours, Last 24 Hours) on the Event Map for this organization.
                    </Typography>
                </Grid>
            </SettingsFieldCard>

        </>
    );
};
